<template>
  <div class="em-block">
    <div class="em-child">
      <div class="row">
        <div class="col">
          <h2>Limits</h2>
          <hr />
        </div>
      </div>
      <view-settings-limit
        v-for="(limit, key, index) in limits"
        v-on:showConditionalRuleModal="showConditionalRuleModal"
        :limit="limit"
        :key="key"
        :index="index"
      ></view-settings-limit>
      <div class="cta">
        <button class="btn grey-to-blue" @click="addLimit">+ Add Limit</button>
      </div>
    </div>
    <conditional-display-modal
      v-if="selectedRuleSet"
      :parent="selectedLimit"
      :ruleSet="selectedRuleSet"
      :state="modalStateFor(vueModalID.conditionalDisplay)"
      :index="vueModalID.conditionalDisplay"
      :key="selectedRuleSet.client_id"
      @toggle-modal="hideConditionalDisplayModal"
    ></conditional-display-modal>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import SelectedMixin from "../mixins/selectedMixin";
import ConditionalDisplayModal from "~/components/conditionalRuleBuilder/conditionalDisplayModal.vue";
import ConditionalDisplayRule from "~/components/conditionalRuleBuilder/conditionalDisplayRule.vue";
import ConditionalRuleSetFactory from "../../../common/models/conditionalRules/conditionalRuleSetFactory";
import ObjectModelConditionalFields from "~/models/objectModels/objectModelConditionalFields";
import ObjectModelLimit from "../../../common/models/objectModelLimit";
import ViewSettingsLimit from "./view-settings-limit.vue";

export default Vue.extend({
  components: { ConditionalDisplayModal, ConditionalDisplayRule, ViewSettingsLimit },
  mixins: [SelectedMixin],
  data: function() {
    return { selectedRuleSet: null, selectedLimit: null };
  },
  computed: {
    limits() {
      return this.selectedObjectModel.object_model_limits;
    }
  },
  methods: {
    addLimit() {
      this.selectedObjectModel.createLimit(this.selectedObjectModel);
    },
    showConditionalRuleModal(selectedConditionalRule, selectedLimit) {
      this.selectedRuleSet = selectedConditionalRule;
      this.selectedLimit = selectedLimit;
      this.showModal(this.vueModalID.conditionalDisplay);
    },
    hideConditionalDisplayModal(): void {
      this.selectedRuleSet = null;
      this.selectedLimit = null;
      this.hideModal(this.vueModalID.conditionalDisplay);
    }
  }
});
</script>